import $ from "jquery";

const initTooltips = function (selector) {
  let opts = {html: true, placement: 'top'};
  let context = $(selector)
  let tooltips = $(context).find('.js-tooltip').tooltip(opts);
  tooltips.on('click', function (ev) {
    ev.preventDefault();
  });

  tooltips.on('mouseenter', function (ev) {
    let classes = $(ev.currentTarget).data("classes");
    let tooltipId = $(ev.currentTarget).attr("aria-describedby");
    let tooltipObject = $("#" + tooltipId);

    if (typeof classes != 'undefined') {
      let classesArray = classes.split(" ");
      for (let i = 0; i < classesArray.length; i++) {
        if (!tooltipObject.hasClass(classesArray[i])) {
          tooltipObject.addClass(classesArray[i]);
        }
      }
    }
  });
}

export {initTooltips};
